var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarImageUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28631 0.491394C8.14139 0.190613 7.83514 -0.000793457 7.49881 -0.000793457C7.16248 -0.000793457 6.85896 0.190613 6.71131 0.491394L4.95311 4.10897L1.02654 4.68866C0.698418 4.73788 0.424981 4.96757 0.323809 5.28202C0.222637 5.59647 0.304668 5.94374 0.539825 6.17616L3.38904 8.9953L2.71639 12.9793C2.6617 13.3074 2.79842 13.641 3.06912 13.8351C3.33982 14.0293 3.69803 14.0539 3.99334 13.898L7.50154 12.025L11.0097 13.898C11.3051 14.0539 11.6633 14.032 11.934 13.8351C12.2047 13.6383 12.3414 13.3074 12.2867 12.9793L11.6113 8.9953L14.4605 6.17616C14.6957 5.94374 14.7804 5.59647 14.6765 5.28202C14.5726 4.96757 14.3019 4.73788 13.9738 4.68866L10.0445 4.10897L8.28631 0.491394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImageUpgrade);
export default __webpack_public_path__ + "static/media/star-image-upgrade.0ff32ce8d72b2378ce77b4c3c4c1b442.svg";
export { ForwardRef as ReactComponent };